export default {
    common: {
        default: "文档",
        kicker: "用户协议",
        navTitle: "公共文档",
        empty: "暂无文档内容",
        terms: "服务条款",
        termsDesc: "服务使用规则",
        privacy: "隐私政策",
        privacyDesc: "数据与隐私说明",
    },
};
